module.exports = __webpack_public_path__ + "static/media/karmaLogo.03556d9e.png";